import { Routes, Route, Navigate } from "react-router-dom";
import { Layout } from "./routes/layout";
import { LoginPage } from "./routes/login";
import { SignupPage } from "./routes/signup";
import { HomePage } from "./routes/home";
import { PricingPage } from "./routes/pricing";
import { CheckoutPage } from "./routes/checkout";
import { CheckoutReturnPage } from "./routes/checkout-return";
import { AccountPage } from "./routes/account";
import { AccountCancelPage } from "./routes/account-cancel";
import { LogoutRoute } from "./routes/logout";
import { VerifyEmailPage } from "./routes/verify-email";
import { CompleteProfilePage } from "./routes/complete-profile";
import { ForgotPasswordPage } from "./routes/forgot-password";
import { LinkAccountPage } from "./routes/link-account";
import { AdminUsersPage } from "./routes/admin-users";
import { AdminUserDetailPage } from "./routes/admin-user-detail";
import { AdminRequestsPage } from "./routes/admin-requests";
import { PAYMENTS_ENABLED } from "./lib/payments";
import { AdminGuard } from "./components/admin-guard";

export function App() {
  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<Navigate to="/home" replace />} />
        <Route path="login" element={<LoginPage />} />
        <Route path="signup" element={<SignupPage />} />
        <Route path="verify-email" element={<VerifyEmailPage />} />
        <Route path="complete-profile" element={<CompleteProfilePage />} />
        <Route path="forgot-password" element={<ForgotPasswordPage />} />
        <Route path="link-account" element={<LinkAccountPage />} />
        <Route path="home" element={<HomePage />} />
        {/* PayPal is dormant: the pages stay in the code, but every way in —
            including TVM's and TVD's "subscribe" links to /pricing — lands on
            /home, where licenses are requested. */}
        <Route path="pricing" element={PAYMENTS_ENABLED ? <PricingPage /> : <Navigate to="/home" replace />} />
        <Route path="checkout" element={PAYMENTS_ENABLED ? <CheckoutPage /> : <Navigate to="/home" replace />} />
        <Route
          path="checkout/return"
          element={PAYMENTS_ENABLED ? <CheckoutReturnPage /> : <Navigate to="/home" replace />}
        />
        <Route path="account" element={<AccountPage />} />
        <Route path="account/cancel" element={<AccountCancelPage />} />
        <Route path="logout" element={<LogoutRoute />} />
        <Route path="admin" element={<AdminGuard><AdminUsersPage /></AdminGuard>} />
        <Route path="admin/users/:uid" element={<AdminGuard><AdminUserDetailPage /></AdminGuard>} />
        <Route path="admin/requests" element={<AdminGuard><AdminRequestsPage /></AdminGuard>} />
      </Route>
    </Routes>
  );
}
